/* unplugin-vue-components disabled */import { render } from "./404.vue?vue&type=template&id=64a0df3d"
const script = {}

import exportComponent from "D:\\云盘\\SynologyDrive\\Synology Drive\\文件\\客户调查表\\customweb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__